import React, { forwardRef } from 'react';

const CollapseIcon = forwardRef((props, ref) => {
  const {
    style: { color },
    ...otherProps
  } = props;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={10}
      height={6}
      viewBox="0 0 10 6"
      fill="none"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.55893 0.240011L5.00092 0.819012L4.4429 0.240011C4.51483 0.16437 4.6014 0.104143 4.69733 0.0629883C4.79325 0.0218337 4.89654 0.000610352 5.00092 0.000610352C5.1053 0.000610352 5.20858 0.0218337 5.3045 0.0629883C5.40043 0.104143 5.487 0.16437 5.55893 0.240011ZM5.00092 1.97501L1.34891 5.76001C1.27689 5.83568 1.19028 5.89593 1.09427 5.93709C0.998262 5.97826 0.894866 5.99949 0.790405 5.99949C0.685945 5.99949 0.582579 5.97826 0.486572 5.93709C0.390565 5.89593 0.303918 5.83568 0.231903 5.76001C0.0836241 5.6039 0.000976562 5.39682 0.000976563 5.18151C0.000976562 4.96621 0.0836241 4.75912 0.231903 4.60301L4.4429 0.239012L5.00092 0.818012L5.55893 0.239012L9.76993 4.60301C9.91821 4.75912 10.0009 4.96621 10.0009 5.18151C10.0009 5.39682 9.91821 5.6039 9.76993 5.76001C9.69791 5.83568 9.61127 5.89593 9.51526 5.93709C9.41925 5.97826 9.31589 5.99949 9.21143 5.99949C9.10697 5.99949 9.00357 5.97826 8.90756 5.93709C8.81155 5.89593 8.72494 5.83568 8.65292 5.76001L5.00092 1.97501Z"
        fill={color}
      />
    </svg>
  );
});

CollapseIcon.defaultProps = {
  style: {
    color: '#454545',
  },
};

export default CollapseIcon;
